module.exports = __webpack_public_path__ + "img/team-blue.ee51eb65.svg";